import { render, staticRenderFns } from "./vselect.vue?vue&type=template&id=73a873c6"
import script from "./vselect.vue?vue&type=script&lang=js"
export * from "./vselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports